import type { JSX } from 'react';
import aosphereLogoWhite from '../assets/images/error/aoslogin-experts-logo-white.svg';

/**
 * Centered brand lockup for the full-page error/not-found screens — the aosphere
 * wordmark, white-on-transparent for the dark map-gradient background. Ported from
 * aosphere-nextgenui-user's AosBrandLockup (same asset).
 */
export function BrandLockup(): JSX.Element {
  return (
    <div className="d-flex align-items-center justify-content-center w-100">
      <img
        alt="aosphere"
        src={aosphereLogoWhite}
        style={{ height: 'auto', width: '100%', maxWidth: 420 }}
      />
    </div>
  );
}
